import type * as React from 'react';
import { get } from '@Domain/Api';
import passwordSignInUserCountFetched, {
	type PasswordSignInUserCountFetchedAction,
} from '@Application/Security/Sso/Actions/passwordSignInUserCountFetched';
import passwordSignInUserCountFetchFailed, {
	type PasswordSignInUserCountFetchFailedAction,
} from '@Application/Security/Sso/Actions/passwordSignInUserCountFetchFailed';
import type FetchPasswordSignInUserCount from '@Application/Security/Sso/Queries/FetchPasswordSignInUserCount';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = PasswordSignInUserCountFetchedAction | PasswordSignInUserCountFetchFailedAction;

type PaginatedUsers = {
	totalRecords: number;
	results: unknown[];
};

// Reads the account-scoped user list but writes nothing to `usersStore`: dispatching `fetchUsers`
// here would overwrite that screen's own paginated list with this single-row page. Independent of
// `fetchIdentityProvider` on purpose — it must render its count even when the configuration answers
// 404, which is exactly when the count is highest and most useful.
export default (query: FetchPasswordSignInUserCount) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<PaginatedUsers>(
				`${parameters.api.host}/api/accounts/${query.accountId}/users?${query.queryParams.toString()}`,
			);

			const action = passwordSignInUserCountFetched(
				{ passwordSignInUserCount: response.totalRecords },
				query.accountId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = passwordSignInUserCountFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
